/* Purrfolk article: share button (Web Share API with clipboard fallback). Loaded with defer. */
(function () {
  'use strict';

  var canShare = typeof navigator !== 'undefined' && typeof navigator.share === 'function';

  function notify(message) {
    if (!message) return;
    if (window.Purr && typeof window.Purr.toast === 'function') {
      window.Purr.toast(message, { type: 'success' });
    }
  }

  function copyText(text, done) {
    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(text).then(done, function () { legacyCopy(text, done); });
      return;
    }
    legacyCopy(text, done);
  }

  function legacyCopy(text, done) {
    var area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.top = '0';
    area.style.left = '0';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(area);
    if (ok) done();
  }

  function init(root) {
    if (root.hasAttribute('data-purr-share-ready')) return;
    var button = root.querySelector('[data-share-native]');
    if (!button) return;
    root.setAttribute('data-purr-share-ready', '');

    var url = root.getAttribute('data-share-url') || window.location.href;
    var title = root.getAttribute('data-share-title') || document.title;
    var copiedText = root.getAttribute('data-copied-text') || '';
    var copyLabel = root.getAttribute('data-copy-label') || '';

    if (!canShare && copyLabel) button.setAttribute('aria-label', copyLabel);

    function copyLink() {
      copyText(url, function () { notify(copiedText); });
    }

    button.addEventListener('click', function () {
      if (!canShare) { copyLink(); return; }
      navigator.share({ title: title, url: url }).catch(function (err) {
        if (err && err.name === 'AbortError') return;
        copyLink();
      });
    });
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-purr-share]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
